module.exports = __webpack_public_path__ + "img/1557959189.54c1ef68.jpg";